export default "__VITE_ASSET__CunRw8PF__"